import Vue from 'vue'
import App from './App.vue'
import router from './router'

import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vuetify from 'vuetify'
Vue.use(Vuetify);
import 'vuetify/dist/vuetify.min.css'
Vue.config.productionTip = false

import axios from 'axios'
import VueAxios from 'vue-axios'
const instance = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  withCredentials: true,
});
Vue.use(VueAxios, instance)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
